<template>
<!-- 
    title="请选择需要更新的可行配方" -->
    <a-modal
    :visible="visible.resTask"
    width="900px"
    :bodyStyle="{padding:'10px'}"
    title="更新配方"
    @cancel="toggleVisible('resTask')"
    @ok="save"
  >
  <div style="padding: 0 15px;">
    <h3 style="font-weight: bold;margin-bottom: 20px;">选择可行配方</h3>
    <a-spin :spinning="resLoading" tip="配方更新中">
      <a-table
        :columns="columns"
        bordered
        :scroll="{ x:0, y: 450 }"
        :loading="rawListLoading"
        :data-source="list.records"
        :row-selection="{selectedRowKeys, onChange: onSelectChange}"
        :row-key="record => record.id"
        :pagination="false"
      >
        <span slot="uasge" slot-scope="text">{{text == null ? text : text.toFixed(3)}}</span>
      </a-table>
      <h3 style="font-weight: bold;margin-top:20px">选择更新数据</h3>
      <a-form class="headForm" :label-col="{ span: 2 }">
          <a-form-item label="原料">
            <a-checkbox-group v-model="materialArr">
              <a-checkbox value="updateRawPriceFlag">
                原料价格
              </a-checkbox>
              <a-checkbox value="updateAddDelRawFlag">
                增加、删除的原料
              </a-checkbox>
            </a-checkbox-group>
          </a-form-item>
          <a-form-item label="配方优化">
            <a-checkbox-group v-model="formulaArr">
              <a-checkbox value="updateMinMaxFlag">
                原料用量、最大值、最小值；营养需要量数值、最小值、最大值
              </a-checkbox>
            </a-checkbox-group>
          </a-form-item>
        </a-form>
    </a-spin>
  </div>
  
  </a-modal>
</template>

<script>
import { formulaMixins } from '../unitls'
export default {
  mixins:[formulaMixins],
  data(){
    return {
      rawListLoading:false,
      resLoading:false,
      columns:[
        {
          dataIndex:'formulaCode',
          title:'配方代码'
        },
        {
          dataIndex:'formulaName',
          title:'配方名称'
        },
        {
          dataIndex:'animalTypeName',
          title:'动物类型'
        },
        {
          dataIndex:'factoryName',
          title:'工厂名称'
        }
      ],
      materialArr: [],
      formulaArr: []
    }
  },
  computed:{
    checkArr(){
      return [...this.materialArr,...this.formulaArr]
    }
  },
  watch:{
    'visible.resTask'(val){
      if(val){ 
        this.materialArr = ['updateRawPriceFlag','updateAddDelRawFlag'],
        this.formulaArr = ['updateMinMaxFlag']
        this.getList()
      } else {
        this.cleanSelect()
      }
    }
  },
  methods:{
    getList(arg = {}) {
      this.fetchGet({
        actions: this.selectSpeedFormulaTaskFormulaHaveSolutionPage,
        name: 'list',
        loading: "rawListLoading",
        data: {
          current: 1,
          taskId: this.$route.query.id,
          size: 1000,
          ...arg
        }
      });
    },
    async save(){
      if(this.selectedRows.length > 0 && this.checkArr.length > 0){
        await this.fetchPost({
          actions: this.updateSpeedOrgFormulaByIds,
          loading:'resLoading',
          data: {
            ids:this.selectedRows.map(i=>i.id).join(),
            taskId: this.$route.query.id,
            updateAddDelRawFlag: this.checkArr.indexOf('updateAddDelRawFlag') >= 0 ? '1' : '0',
            updateMinMaxFlag: this.checkArr.indexOf('updateMinMaxFlag') >= 0 ? '1' : '0',
            updateRawPriceFlag: this.checkArr.indexOf('updateRawPriceFlag') >= 0 ? '1' : '0'
          }
        })
        this.toggleVisible('resTask')
        this.setState({
          resRaw:this.resRaw + 1,
          resNut:this.resNut + 1,
        })
      } else {
        if(this.selectedRows.length === 0) {
          this.$message.warn('请选择要更新的配方')
          return
        }
        if(this.checkArr.length === 0){
          this.$message.warn('请选择要更新的数据')
        }
      }
    }
  },
}
</script>

<style>

</style>